import { nn } from '@liveblocks/core';
import { createContext, useContext } from 'react';

const EmojiPickerContext = createContext(
  null
);
function useEmojiPicker() {
  const emojiPickerContext = useContext(EmojiPickerContext);
  return nn(
    emojiPickerContext,
    "EmojiPicker.Root is missing from the React tree."
  );
}

export { EmojiPickerContext, useEmojiPicker };
//# sourceMappingURL=contexts.mjs.map
